import React from 'react';
import PropTypes from 'prop-types';
import ConnectedLoginForm from './ConnectedLoginForm';

// TODO: Move to react-viewerbase

function LoginRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedLoginForm />;
}

LoginRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default LoginRouting;
